import React, { Fragment } from 'react';
import { CardBody } from 'reactstrap';
import {
	_capitalizeText,
	_formatNumber,
	_getBuildingURL,
	BuildingPhoto,
	_replaceAbbreviations,
	_shouldShow,
	_formatUnitNumber,
	UnitCurrentStatus,
	_nameToUrl,
	_getBuildingPhotos,
} from '../../../shared/helpers/utils';
import UnitIcons from '../../../shared/components/UnitIcons';

const UnitsGridView = ({ data, onUnitClick, building }) => {
	return (
		<div className="catalog-items__wrap" style={{ padding: '0 15px' }}>
			<div className="catalog-items">
				{data.map((d) => {
					const imgUrl = _getBuildingPhotos(d, '')[0];
					return (
						<CardBody
							className="catalog-item"
							key={d.id}
							onClick={(e) => onUnitClick(e, d)}
							style={{ cursor: 'pointer' }}
						>
							<div className="catalog-item__img-wrap">
								{imgUrl ?
									<img
										src={imgUrl}
										alt=""
										style={{ width: '100%', height: '100%', objectFit: 'cover' }}
									/>
									:
									<BuildingPhoto item={d} />
								}
							</div>
							<UnitCurrentStatus status={d.offering_status} unit={d} />
							<div className="catalog-item__info">
								<h4 className="catalog-item__price">
									{d.name ? _capitalizeText(d.name) : _capitalizeText(_replaceAbbreviations(d.display_full_street_address))}
									{d.address_2_normalized && `, ${d.address_2_normalized.toUpperCase().replace("APT", "Apt")}`}
									<UnitIcons building={building} unit={d} />
									<div className="light-text small-text" style={{ color: '#858AA1' }}>
										{d.neighborhood && d.neighborhood[0] ? `${_capitalizeText(d.neighborhood[0])}, ` : ''}
										{_capitalizeText(d.borough)}
									</div>
								</h4>
								<h5 className="product-card__title">
									{d.bedrooms > -1 && (
										<span className="light-text small-text">
											{d.bedrooms === 0 ? 'Studio' : d.bedrooms + ' Bed'}
										</span>
									)}
									{d.baths > 0 && (
										<Fragment>
											<span className="small-divider">|</span>
											<span className="light-text small-text">{d.baths} Bath</span>
										</Fragment>
									)}
									{_shouldShow(d.sq_ft) && (
										<Fragment>
											<span className="small-divider">|</span>
											<span className="light-text small-text">{_formatNumber(d.sq_ft)} sf</span>
										</Fragment>
									)}
								</h5>
								<div style={{ marginTop: 4 }}>
									{d.last_listed_sale_price_all > 100 && (
										<div className="light-text small-text">
											Asking: <strong>${_formatNumber(d.last_listed_sale_price_all)}</strong>
										</div>
									)}
									{d.last_listed_rent_price_all > 0 && (
										<div className="light-text small-text">
											Rent: <strong>${_formatNumber(d.last_listed_rent_price_all)}/mo</strong>
										</div>
									)}
									{d.last_sold_price > 100 && (
										<div className="light-text small-text" style={{ marginTop: 2 }}>
											Sold: <strong>${_formatNumber(d.last_sold_price)}</strong>
										</div>
									)}
								</div>
							</div>
						</CardBody>
					);
				})}
			</div>
		</div>
	);
};

export default UnitsGridView;
